import { schema } from 'normalizr';
import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { LightProject } from 'types/project';
import type { ReportEntity } from 'types/reports';
import { actionCreatorFactory } from 'typescript-fsa';

export const pinsXhrModule = createXhrStatusModule('pins');

const actionCreator = actionCreatorFactory('timely/pins');
export const fetchedProjectPins = actionCreator<{ projects: Array<LightProject> }>(
  'FETCHED_PROJECT_PINS'
);
export const toggleProjectPin = actionCreator<{ projectId: number }>('TOGGLE_PROJECT_PIN');
export const fetchedReportsPins = actionCreator<{ reports: Array<ReportEntity> }>(
  'FETCHED_REPORTS_PINS'
);
export const toggleReportPin = actionCreator<ReportEntity>('TOGGLE_REPORT_PIN');

export interface PinsState {
  projectIds: Array<number>;
  reportEntities: Record<number, ReportEntity>;
  reportResult: Array<number>;
  xhrStatus: XhrStatus;
}
export const pinsSchema = new schema.Entity<ReportEntity>('pins');
export const pinsListSchema = [pinsSchema];
